import * as React from 'react';
import { useSelector } from 'react-redux';

import { AiBannerDesktop } from '../../components/AiBanner/AiBannerDesktop';
import { AiBannerMobile } from '../../components/AiBanner/AiBannerMobile';
import { selectAiSummaryEntryPoint } from '../../selectors/newbuildingsCompare';
import { useApplicationContext } from '../../utils/applicationContext';
import { SUMMARY_ENABLED_CONFIG_KEY } from '../../constants/summary';
import { trackClickAiBanner, trackShowAiBanner } from './tracking';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

export interface IAiBannerContainerProps {
  onOpen: () => void;
  mobile?: boolean;
}

export const AiBannerContainer = ({ onOpen, mobile = false }: IAiBannerContainerProps): React.JSX.Element | null => {
  const aiSummaryEntryPoint = useSelector(selectAiSummaryEntryPoint);
  const { config } = useApplicationContext();
  const isAiSummaryEnabled = config.get<boolean>(SUMMARY_ENABLED_CONFIG_KEY);
  const siteType = mobile ? 'mobile' : 'desktop';

  const handleOpen = React.useCallback(() => {
    trackClickAiBanner(siteType);
    onOpen();
  }, [onOpen, siteType]);

  if (!aiSummaryEntryPoint || !isAiSummaryEnabled) {
    return null;
  }

  return mobile ? (
    <ActionAfterViewObserver callback={() => trackShowAiBanner(siteType)}>
      <AiBannerMobile {...aiSummaryEntryPoint} onOpen={handleOpen} />
    </ActionAfterViewObserver>
  ) : (
    <ActionAfterViewObserver callback={() => trackShowAiBanner(siteType)}>
      <AiBannerDesktop {...aiSummaryEntryPoint} onOpen={handleOpen} />
    </ActionAfterViewObserver>
  );
};
